import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import HeroBannerDisplay from './HeroBannerDisplay';

class HeroBannerContainer extends React.Component {
  static propTypes = {
    loadAccount: PropTypes.func.isRequired,
    saveAccount: PropTypes.func.isRequired,
    carrierAccount: PropTypes.object,
    loading: PropTypes.bool,
    history: PropTypes.object
  }

  static defaultProps = {
    carrierAccount: undefined,
    loading: undefined,
    history: undefined
  }

  state = {
    addAccount: false,
    newLicenseNumber: '',
    errors: {
      newLicenseNumberError: undefined
    }
  };

  componentWillMount() {
    this.props.loadAccount();
  }

  componentDidUpdate(prevProps) {
    if (this.props.posting !== prevProps.posting && this.props.posting === false && this.props.error === false) {
      this.props.postAccountReset();
    }
    if (this.props.posting !== prevProps.posting && this.props.posting === undefined && this.props.error === false) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ addAccount: false, newLicenseNumber: '' }, () => this.props.loadAccount());
    }
  }

  toggleAddAccount = () => {
    this.setState(state => ({ addAccount: !state.addAccount }));
  };

  handleOnChange = (newValue) => {
    this.setState({ newLicenseNumber: newValue });
  }

  cancelAdd = () => {
    this.setState({ addAccount: false, newLicenseNumber: '', errors: { newLicenseNumberError: undefined } });
  }

  handleNewAccountSubmit = () => {
    const errors = this.validateAccount();
    if (errors === null) {
      const account = { ...this.props.carrierAccount };
      const array = [...account.CarrierAccounts];
      array.push(this.state.newLicenseNumber);
      account.CarrierAccounts = array;
      this.props.saveAccount(account);
      this.setState({ newLicenseNumber: '', errors: { newLicenseNumberError: undefined } });
    } else {
      this.setState({ errors });
    }
  }

  validateAccount = () => {
    const errors = {};
    const number = this.state.newLicenseNumber;
    const adjustedNumber = number.replace(/_/g, '').trim();
    if (adjustedNumber.length !== 9) {
      errors.newLicenseNumberError = 'FedEx account numbers must be 9 digits, all numbers.';
    }
    if (Object.keys(errors).length !== 0) {
      return errors;
    }
    return null;
  }

  render() {
    const { loading, history } = this.props;
    return (
      <div>
        { loading === false
          ? (
            <HeroBannerDisplay
              addAccount={ this.state.addAccount }
              toggleAddAccount={ this.toggleAddAccount }
              history={ history }
              { ...this.props }
              newLicenseNumber={ this.state.newLicenseNumber }
              newLicenseChange={ this.handleOnChange }
              cancelAdd={ this.cancelAdd }
              handleNewAccountSubmit={ this.handleNewAccountSubmit }
              errors={ this.state.errors }
            />
          )
          : <div />
        }
      </div>
    );
  }
}

export default withRouter(HeroBannerContainer);
